/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRouteDetails.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/route-details";

export class AutogenModelRouteDetails<RowType extends ModelRow> extends Endpoint<RowType, RowRouteDetailsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRouteDetails extends ModelRow<RowRouteDetailsFields> {
	constructor(values?: Partial<RowRouteDetailsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRouteDetailsFields {
	accum_dist_um: string;
	accumulated_dist: string;
	accumulated_time: string;
	city_id_1: number;
	city_id_2: number;
	company_id: string;
	dest_city_id: number;
	direction: string;
	distance_profile: string;
	distance_um: string;
	hazmat_type: string;
	highway: string;
	leg_dest_location: string;
	leg_distance: string;
	leg_distance_um: string;
	line_number: number;
	lookup_type: string;
	method: string;
	non_toll_dist: number;
	non_toll_dist_um: string;
	notes: string;
	origin_city_id: number;
	source: string;
	state: string;
	toll_amount: number;
	toll_amount_c: string;
	toll_amount_d: Date;
	toll_amount_n: number;
	toll_amount_r: number;
	toll_distance: number;
	toll_distance_um: string;
}

